import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTransfers } from './api.js';
import { TransferRow } from './TransferRow.js';
import { LoadingScreen } from '../../components/Status/LoadingScreen.js';
import { ErrorState } from '../../components/Status/ErrorState.js';
import { EmptyState } from '../../components/Status/EmptyState.js';

export function TransferHistoryPage() {
  const { t } = useTranslation();
  const transfersQ = useTransfers();
  const [query, setQuery] = useState('');

  const items = useMemo(() => {
    const all = transfersQ.data?.items ?? [];
    const lowered = query.trim().toLowerCase();
    if (!lowered) return all;
    return all.filter((item) => item.reference_code.toLowerCase().includes(lowered));
  }, [transfersQ.data?.items, query]);

  if (transfersQ.isLoading) return <LoadingScreen />;
  if (transfersQ.isError) return <ErrorState onRetry={() => transfersQ.refetch()} />;
  if (!transfersQ.data?.items.length) return <EmptyState title={t('transfers.noResults')} />;

  return (
    <div className="mx-auto max-w-3xl space-y-8">
      <div className="space-y-5">
        <h1 className="text-5xl font-semibold tracking-tight text-primary">
          {t('transfers.title')}
        </h1>
        <div className="rounded-[2rem] border border-border px-5 py-4">
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t('transfers.searchPlaceholder')}
            className="w-full bg-transparent text-lg text-text outline-none placeholder:text-text-muted"
          />
        </div>
      </div>

      <ul className="flex flex-col">
        {items.map((transfer) => (
          <li key={transfer.id}>
            <TransferRow transfer={transfer} />
          </li>
        ))}
      </ul>
    </div>
  );
}
